import { render, staticRenderFns } from "./EditListDetails.vue?vue&type=template&id=3b8f5a84&scoped=true&"
import script from "./EditListDetails.vue?vue&type=script&lang=js&"
export * from "./EditListDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditListDetails.vue?vue&type=style&index=0&id=3b8f5a84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f5a84",
  null
  
)

export default component.exports